import { Button, Group } from "@mantine/core";
import IconSend from "@tabler/icons-react/dist/esm/icons/IconSend.mjs";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { changeStatusSearch } from "../../../services/flag";
import axios from "../../../services/axios/config";
import ExportFileButton from "../../../components/ExportFileButton/ExportFileButton";
import {
  useSelectManualSearchEnabled,
  useSelectManualSearchFilters,
  useSelectManualSearchRuleId,
  useSelectManualSearchSearchId,
} from "../../../redux/features/manualSearch/manualSearchSlice";

async function exportManualSearch({ searchId, filters }) {
  const response = await axios({
    url: `search/base/export?id=${searchId}&type=EXCEL`,
    method: "POST",
    responseType: "blob",
    data: filters,
  });

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "manual-search.xlsx");
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export default function ActionsBar({ totalCount = 0 }) {
  const queryClient = useQueryClient();
  const enabled = useSelectManualSearchEnabled();
  const searchId = useSelectManualSearchSearchId();
  const ruleId = useSelectManualSearchRuleId();
  const filters = useSelectManualSearchFilters();

  const hasResults = Boolean(enabled && searchId && totalCount > 0);

  const exportMutation = useMutation({
    mutationFn: () => exportManualSearch({ searchId, filters }),
    onError: (err) => {
      toast.error(err?.response?.data?.message || "Error exporting results");
    },
  });

  const sendForMonitoringMutation = useMutation({
    mutationFn: () => changeStatusSearch("FOR_MONITORING", ruleId, filters),
    onSuccess: async () => {
      toast.success("Flag successfully added.");
      await queryClient.invalidateQueries({
        queryKey: ["manual-search", "table"],
      });
    },
    onError: (err) => {
      toast.error(
        err?.response?.data?.message || "Error sending for monitoring",
      );
    },
  });

  return (
    <Group bg="gray.1" justify="space-between" p="sm">
      <ExportFileButton
        handleDownload={() => exportMutation.mutate()}
        loading={exportMutation.isPending}
        disabled={!hasResults || exportMutation.isPending}
        tooltipLabel="Export in Excel"
        type="EXCEL"
      />
      <Button
        disabled={!hasResults || !ruleId}
        leftSection={<IconSend size={18} />}
        loading={sendForMonitoringMutation.isPending}
        onClick={() => sendForMonitoringMutation.mutate()}
        variant="outline"
      >
        Send for monitoring
      </Button>
    </Group>
  );
}
